export const defaultBudget = null;
export const minimumDefaultPrice = 0;
export const maximumDefaultPrice = 2000000;
